import { render, staticRenderFns } from "./GiveawayForm.vue?vue&type=template&id=1fe72fcb&scoped=true"
import script from "./GiveawayForm.vue?vue&type=script&lang=js"
export * from "./GiveawayForm.vue?vue&type=script&lang=js"
import style0 from "./GiveawayForm.vue?vue&type=style&index=0&id=1fe72fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe72fcb",
  null
  
)

export default component.exports